export default "__VITE_ASSET__BNTgL73___"